import * as React from 'react';
import styles from './variants.module.scss';

interface IVariants {
    items: string[] | undefined;
    limit: number;
}

const Variants: React.FC<IVariants> = ({ items, limit }) => {
    if (undefined === items || !Array.isArray(items) || items.length === 0) {
        return null;
    }

    return (
        <div className={styles.serpVariants}>
            {items.slice(0, limit).map((item, key) => {
                return (
                    <div className={styles.serpVariant} key={key}>
                        {item}
                    </div>
                );
            })}
        </div>
    );
};

export default Variants;
